import type { Episode } from './episode'

export type GuidedWorkflowPhase = 'assessment' | 'stabilization' | 'monitoring' | 'resolution' | 'transition'
export type GuidedStepState = 'completed' | 'current' | 'upcoming'

export interface GuidedWorkflowStep {
  id: GuidedWorkflowPhase
  label: string
  state: GuidedStepState
}

export const guidedWorkflowOrder: Array<{ id: GuidedWorkflowPhase; label: string }> = [
  { id: 'assessment', label: 'Inquadramento' },
  { id: 'stabilization', label: 'Stabilizzazione' },
  { id: 'monitoring', label: 'Monitoraggio' },
  { id: 'resolution', label: 'Risoluzione' },
  { id: 'transition', label: 'Transizione' }
]

const hasTherapyData = (episode: Episode) => {
  if ((episode.treatmentEvents ?? []).length > 0) return true
  return episode.observations.some((observation) => Boolean(
    observation.treatment?.insulinUnitsHour !== undefined ||
    observation.treatment?.fluidMlHour !== undefined ||
    observation.treatment?.fluidType !== undefined ||
    observation.treatment?.potassiumMmolPerL !== undefined ||
    observation.treatment?.potassiumMmolHour !== undefined
  ))
}

export function getGuidedWorkflowPhase(episode: Episode): GuidedWorkflowPhase {
  if (episode.status === 'resolved' || episode.status === 'closed') return 'transition'
  if (episode.status === 'resolution_candidate') return 'resolution'
  if (episode.observations.length <= 1 && !hasTherapyData(episode)) return 'stabilization'
  return 'monitoring'
}

export function getGuidedWorkflowSteps(episode: Episode): GuidedWorkflowStep[] {
  const current = getGuidedWorkflowPhase(episode)
  const currentIndex = guidedWorkflowOrder.findIndex((step) => step.id === current)
  const closed = episode.status === 'closed'
  return guidedWorkflowOrder.map((step, index) => ({
    ...step,
    state: closed || index < currentIndex ? 'completed' : index === currentIndex ? 'current' : 'upcoming'
  }))
}

export function guidedActionTarget(phase: GuidedWorkflowPhase): string {
  if (phase === 'stabilization') return 'terapia-guidata'
  if (phase === 'monitoring') return 'nuova-rivalutazione'
  if (phase === 'resolution') return 'risoluzione-episodio'
  if (phase === 'transition') return 'transizione-ev-sc'
  return 'dettagli-episodio'
}
